export default "__VITE_ASSET__5795925e__"